import { render } from "./Lottiecontainer.vue?vue&type=template&id=61b6ea90"
import script from "./Lottiecontainer.vue?vue&type=script&lang=js"
export * from "./Lottiecontainer.vue?vue&type=script&lang=js"
script.render = render

export default script